jQuery(document).ready(function(){
    jQuery('.hp-carousel').slick({
      dots: true,
      responsive: [
    {
      breakpoint: 480,
      settings: {
        dots: false,
        arrows: false
      }
    }
  ]
    });


    jQuery('.responsive').slick({
  dots: true,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [

    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});

  });


  jQuery('#go-to-top').each(function(){
      jQuery(this).click(function(){
          jQuery('html,body').animate({ scrollTop: 0 }, 'slow');
          return false;
      });
  });
